import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SelectedItemsService {
  selectedItemsMap: { [page: number]: any[] } = {};

  constructor() {}

  toggleItem(page: number, item: any) {
    if (!this.selectedItemsMap[page]) {
      this.selectedItemsMap[page] = [];
    }
    const index = this.selectedItemsMap[page].findIndex((i) => i._id === item._id);
    if (index === -1) {
      this.selectedItemsMap[page].push(item);
    } else {
      this.selectedItemsMap[page].splice(index, 1);
    }
  }

  clearSelectedItems() {
    this.selectedItemsMap = {};
  }

  toggleSelectAll(page: number, items: any[]) {
    if (!this.selectedItemsMap[page] || this.selectedItemsMap[page].length === 0) {
      this.selectedItemsMap[page] = [...items];
    } else {
      this.selectedItemsMap[page] = [];
    }
  }

  isPageSelected(page: number) {
    return this.selectedItemsMap[page] && this.selectedItemsMap[page].length > 0;
  }

  isItemSelected(page: number, item: any) {
    return this.selectedItemsMap[page] && this.selectedItemsMap[page].some((i) => i._id === item._id);
  }

  isAllPageItemsSelected(page, selectedItems) {
    return this.selectedItemsMap[page]?.length === selectedItems?.length;
  }

  getSelectedItems() {
    let mergedMap = [];

    // Iterate over each key in the object
    for (let key in this.selectedItemsMap) {
      // Concatenate the array corresponding to the current key with the merged array
      mergedMap = mergedMap.concat(this.selectedItemsMap[key]);
    }
    return mergedMap;
  }
}
